import { useEffect, useRef } from 'react';

const useScrollSpy = (sectionIds) => {
  const currentSection = useRef(null);
  const ticking = useRef(false);

  useEffect(() => {
    const updateSection = () => {
      let closestSection = null;
      let smallestDistance = Infinity;

      sectionIds.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;

        const rect = el.getBoundingClientRect();
        const distance = Math.abs(rect.top);

        if (rect.top <= 200 && distance < smallestDistance) {
          smallestDistance = distance;
          closestSection = id;
        }
      });

      if (closestSection && currentSection.current !== closestSection) {
        currentSection.current = closestSection;
        history.replaceState(null, '', `#${closestSection}`);
      }

      ticking.current = false;
    };

    const onScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(updateSection);
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', onScroll);
    updateSection();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [sectionIds]);
};

export default useScrollSpy;
